module.exports = __webpack_public_path__ + "img/9788993094336.57d71c86.jpg";